import type { ISerialize } from '@/objects/ISerialize';

export class SignalrTrackingDeviceStatusSubscribeParameters implements ISerialize {
    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {}) {}

    public serialize(): string {
        return '{' + '}';
    }

    /**
     * Creates an instance of SignalrTrackingDeviceStatusSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {}): SignalrTrackingDeviceStatusSubscribeParameters {
        return new SignalrTrackingDeviceStatusSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrTrackingDeviceStatusSubscribeParameters {
        return new SignalrTrackingDeviceStatusSubscribeParameters({});
    }

    /**
     * Creates an instance of SignalrTrackingDeviceStatusSubscribeParameters from another instance of SignalrTrackingDeviceStatusSubscribeParameters.
     * @param other The SignalrTrackingDeviceStatusSubscribeParameters you want to clone
     * @returns A cloned SignalrTrackingDeviceStatusSubscribeParameters
     */
    public static FromOther(other: SignalrTrackingDeviceStatusSubscribeParameters): SignalrTrackingDeviceStatusSubscribeParameters {
        return SignalrTrackingDeviceStatusSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrTrackingDeviceStatusSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrTrackingDeviceStatusSubscribeParameters';
}
